<template>
  <v-form v-model="valid" @submit.prevent ref="form">
    <v-row no-gutters>
      <v-container class="px-8">
        <h2 style="color: var(--v-loginTheme-base)">
          {{ novoAcesso ? 'Cadastre uma senha para seu perfil' : 'Digite sua senha' }}
        </h2>
        <h4 class="mt-5 font-weight-light">
          {{
            novoAcesso
              ? 'Aqui você poderá ver todo os seus exames de saúde ocupacional'
              : 'Olá, digite sua senha abaixo para acessar a plataforma'
          }}
        </h4>
        <template v-if="novoAcesso">
          <v-text-field
            v-model="senha"
            @keydown="preventSpaces"
            :rules="[
              v => $v.senha.required || 'Digite uma senha.',
              v => $v.senha.minLength || 'A sua senha precisa de pelo menos 8 caracteres.',
              v => $v.senha.testeMinuscula || 'A sua senha precisa de pelo menos uma letra minuscula',
              v => $v.senha.testeMaiuscula || 'A sua senha precisa de pelo menos uma letra maiuscula',
              v => $v.senha.testeNumero || 'A sua senha precisa de pelo menos um dígito.',
              v => $v.senha.testeCaracteresEspeciais || 'A sua senha precisa de pelo menos um caractere especial.',
              v => $v.senha.semEspacos || 'A senha não pode conter espaços em branco.'
            ]"
            :type="verSenha ? 'text' : 'password'"
            :append-icon="verSenha ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="verSenha = !verSenha"
            class="mt-8"
            color="loginTheme"
            label="Digite sua senha"
            outlined
          ></v-text-field>
          <v-text-field
            :value="senhaConfirmacao"
            @input="v => $emit('update:senhaConfirmacao', v.replace(/\s/g, ''))"
            @keydown="preventSpaces"
            :rules="[
              v => $v.senhaConfirmacao.required || 'Repita a senha.',
              v => $v.senhaConfirmacao.sameAsPassword || 'As duas senhas não coincidem.'
            ]"
            :type="verSenhaConfirmacao ? 'text' : 'password'"
            :append-icon="verSenhaConfirmacao ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="verSenhaConfirmacao = !verSenhaConfirmacao"
            label="Confirme sua senha"
            outlined
            color="loginTheme"
          ></v-text-field>
        </template>
        <div v-else>
          <v-text-field
            v-model="senha"
            @keydown="preventSpaces"
            :rules="[v => !!v || 'Senha é obrigatória', v => v.length >= 6 || 'Senha deve ter no mínimo 6 caracteres']"
            :type="verSenha ? 'text' : 'password'"
            :append-icon="verSenha ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="verSenha = !verSenha"
            class="mt-8"
            color="loginTheme"
            label="Digite sua senha"
            outlined
          ></v-text-field>
          <v-row no-gutters justify="end">
            <v-btn color="loginTheme" small text @click="$emit('on-recuperar-senha')">Esqueci minha senha</v-btn>
          </v-row>
        </div>
        <v-btn @click="$emit('on-submit')" type="submit" class="mt-5" color="loginTheme" dark rounded block large
          >Continuar</v-btn
        >
        <v-btn @click="$emit('on-voltar')" class="mt-3" color="loginTheme" outlined rounded block large>Voltar</v-btn>
      </v-container>
    </v-row>
  </v-form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'

const caracteresEspeciais = /[#?!@$%^&*-]/
const maiusculaRegex = /[A-Z]/
const minusculaRegex = /[a-z]/
const numeroRegex = /\d/
const espacoRegex = /\s/

export default {
  props: {
    value: {
      type: String,
      required: true
    },
    senhaConfirmacao: {
      type: String,
      default: ''
    },
    checkTermos: {
      type: Boolean,
      required: true
    },
    novoAcesso: {
      type: Boolean,
      default: false
    }
  },
  mixins: [validationMixin],
  validations: {
    senha: {
      required,
      minLength: minLength(8),
      testeCaracteresEspeciais(value) {
        return caracteresEspeciais.test(value)
      },
      testeMaiuscula(value) {
        return maiusculaRegex.test(value)
      },
      testeMinuscula(value) {
        return minusculaRegex.test(value)
      },
      testeNumero(value) {
        return numeroRegex.test(value)
      },
      semEspacos(value) {
        return !espacoRegex.test(value)
      }
    },
    senhaConfirmacao: {
      required,
      sameAsPassword: sameAs('senha')
    }
  },
  data: () => ({
    valid: false,
    verSenha: false,
    verSenhaConfirmacao: false
  }),
  computed: {
    senha: {
      get() {
        return this.value
      },
      set(value) {
        const valorSemEspacos = value.replace(/\s/g, '')
        this.$emit('input', valorSemEspacos)
      }
    }
  },
  methods: {
    preventSpaces(event) {
      if (event.key === ' ') {
        event.preventDefault()
      }
    },
    validate() {
      return this.$refs.form.validate()
    }
  }
}
</script>
